var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-dialog',{ref:"dialog",attrs:{"full-width":"","full-height":""},on:{"hide":_vm.onDialogHide}},[_c('q-card',{staticClass:"q-dialog-plugin"},[_c('PDFViewer',{staticStyle:{"height":"100vh","width":"100vw"},attrs:{"source":_vm.url},on:{"download":_vm.handleDownload}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }